import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { ReviewHeroImageWithRating, HeroImage } from "../shared/hero-image";
import StoryCard from "../shared/story-card";
import Breadcrumb from "../shared/breadcrumbs";
import { ScrollPercentage } from "react-scroll-percentage";
import { Progressbar, feedEvent } from "../shared/progress-bar";
import { DfpAd } from "../../../../atoms/dfp-ad";
import { CategoryBadge } from "../../../../atoms/category-badge";
import { isPremium } from "../../../../../../isomorphic/data/story";
import Vuukle from "../shared/vuukle";
import { GA, LoadVuukle } from "../../../../../integrations";
import StoryMidPromotion from "../../storyMidContent";
import styles from "../text-story-page/styles.m.css";

class ReviewStory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
      story: {},
      viewComment: false,
      sevenFree: true,
      allowDM: false,
      userType: ""
    };
    this.outerarticle = React.createRef();
    this.vuukleCommentPoint = React.createRef();
  }

  toggleBox = (Id = "", action = true) => {
    const story = get(this.props, ["story"], () => null);
    LoadVuukle.register(story, this.props.config.vikatanHosts);
    if (action) {
      window.scrollTo({
        top: this.outerarticle.current.offsetTop - 50
      });
    }
    this.setState(oldState => ({ isOpened: !oldState.isOpened }));
    feedEvent(this.props, this.state.isOpened);
  };

  setView = (action = false) => {
    if (action === true) {
      window.scrollTo({
        top: this.outerarticle.current.offsetTop + this.outerarticle.current.offsetHeight - 100,
        behavior: "smooth"
      });
    } else {
      const story = get(this.props, ["story"], () => null);
      LoadVuukle.register(story, this.props.config.vikatanHosts);
      window.scrollTo({
        top: this.outerarticle.current.offsetTop - 50
      });
      this.setState(oldState => ({ isOpened: !oldState.isOpened }));
    }
  };

  VuukleCommentView = () => {
    const story = get(this.props, ["story"], () => null);
    if (!this.state.viewComment) {
      LoadVuukle.register(story, this.props.config.vikatanHosts);
      this.setState({ viewComment: true });
      GA.customEvent(`feed_comment_click`, `${story.id}`, true);
    }
    window.scrollTo({
      top: this.vuukleCommentPoint.current.offsetTop - 130,
      behavior: "smooth"
    });
  };

  componentDidMount() {
    const variant = this.props.versionStat;
    const story = get(this.props, ["story"], () => null);
    LoadVuukle.register(story, this.props.config.vikatanHosts);
    if (this.props.index === 0) {
      this.setState({ isOpened: variant === "v4" || false });
    }
    if (global.userPromise) {
      global.userPromise.catch(() => null).then(user => {
        this.setState({ userType: user.userType });
      });
    }
  }

  render() {
    const props = this.props;
    const { isOpened, viewComment, sevenFree } = this.state;
    const renderFooter = get(props, ["renderFooter"], () => null);
    const renderHeaderCard = get(props, ["renderHeaderCard"], () => null);
    const renderPremiumCard = get(props, ["renderPremiumCard"], () => null);
    const renderSecondaryCard = get(props, ["renderSecondaryCard"], () => null);
    const renderReadMore = get(props, ["READMORE_ENABLE"]);
    const storyHeadline = get(props, ["story", "subheadline"], () => null);
    const StoryId = get(props, ["story", "id"], () => null);

    const story = get(props, ["story"], () => null);
    return (
      <div className={styles["main-content"]} ref={this.outerarticle}>
        <ScrollPercentage>
          {({ percentage, ref, entry }) => {
            return (
              <article
                className={`infinity-template ${renderReadMore ? styles["nextstory-sec"] : styles["mainstory-sec"]} ${
                  styles["story-body"]
                } js-story`}
                ref={ref}
              >
                <div onClick={() => !this.state.isOpened && this.toggleBox(StoryId)} style={{ cursor: "pointer" }}>
                  {renderHeaderCard({ readMore: isOpened })}
                  {!isOpened && renderSecondaryCard()}
                  {!isOpened ? (
                    <HeroImage story={props.story} className={renderReadMore ? "remove-margin" : ""} />
                  ) : (
                    <ReviewHeroImageWithRating story={props.story} />
                  )}
                  {!isOpened && <CategoryBadge icon="shortform" headline="Short Form" />}
                  <p className={`${styles["subheadline"]}`}>{storyHeadline}</p>
                </div>
                {renderPremiumCard()}
                {isOpened && (
                  <div className="content-section">
                    {props.story.cards.map((card, index) => (
                      <React.Fragment key={card.id}>
                        {index === 2 &&
                          !isPremium(props.story) && <DfpAd story={props.story} adtype="VDO_AI_1" placement="story" />}

                        <StoryCard card={card} story={props.story} config={props.config} />
                      </React.Fragment>
                    ))}
                    <div id="we-story-end" />
                    {<StoryMidPromotion story={this.props.story} />}

                    {renderFooter()}
                  </div>
                )}
                <div ref={this.vuukleCommentPoint}>
                  {isOpened || viewComment ? (
                    <Vuukle story={story} vuukleConfig={LoadVuukle} login={this.props.config.vikatanHosts} />
                  ) : (
                    ""
                  )}
                </div>
                {!renderReadMore ? (
                  isOpened === false ? (
                    <div className="loadmore-stories">
                      <Progressbar
                        scroll={percentage.toFixed(2)}
                        {...this.props}
                        handleSetView={this.setView}
                        handleVuukleCommentView={this.VuukleCommentView}
                        className="next-stories"
                        isOpened={isOpened}
                        showMe={sevenFree}
                      />
                    </div>
                  ) : (
                    <Progressbar
                      scroll={percentage.toFixed(2)}
                      {...this.props}
                      handleSetView={this.setView}
                      handleVuukleCommentView={this.VuukleCommentView}
                      className="main-story"
                      isOpened={isOpened}
                      showMe={sevenFree}
                    />
                  )
                ) : isOpened === false ? (
                  <div className="loadmore-stories">
                    <Progressbar
                      scroll={percentage.toFixed(2)}
                      {...this.props}
                      handleSetView={this.setView}
                      handleVuukleCommentView={this.VuukleCommentView}
                      className="next-stories"
                      isOpened={isOpened}
                      showMe={sevenFree}
                    />
                  </div>
                ) : (
                  <Progressbar
                    scroll={percentage.toFixed(2)}
                    {...this.props}
                    handleSetView={this.setView}
                    handleVuukleCommentView={this.VuukleCommentView}
                    className="main-story"
                    isOpened={isOpened}
                    showMe={sevenFree}
                  />
                )}
              </article>
            );
          }}
        </ScrollPercentage>
      </div>
    );
  }
}
const story = PropTypes.shape({
  id: PropTypes.string,
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      "avatar-url": PropTypes.string,
      "avatar-s3-key": PropTypes.string,
      "twitter-handle": PropTypes.string,
      bio: PropTypes.string
    })
  ),
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      "role-name": PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string
        })
      )
    })
  ),
  headline: PropTypes.string.isRequired,
  alternative: PropTypes.shape({
    home: PropTypes.shape({
      default: PropTypes.shape({
        headline: PropTypes.string
      })
    })
  }),
  slug: PropTypes.string.isRequired,
  "hero-image-metadata": PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
    "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
  }),
  "hero-image-s3-key": PropTypes.string,
  "hero-image-caption": PropTypes.string,
  cards: PropTypes.arrayOf(StoryCard.propTypes.card),
  "linked-stories": PropTypes.any
});
ReviewStory.propTypes = {
  story: story,
  config: Breadcrumb.propTypes.config,
  renderAuthorDetails: PropTypes.func,
  renderComments: PropTypes.func,
  renderReactions: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderSocialMedia: PropTypes.func,
  renderTags: PropTypes.func,
  fireVirtualPageView: PropTypes.func,
  checkInfoStatus: PropTypes.func,
  versionStat: PropTypes.string,
  renderSecondaryCard: PropTypes.func,
  index: PropTypes.number
};

export { ReviewStory };
